"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _constants = require("../utils/constants");

var _default = {
  title: 'Spacing Between Items',
  description: "Set the margin between items.\n    This option is not relevant to some layouts: Slideshow, Thumbnails.",
  isRelevant: function isRelevant(styleParams) {
    return true;
  },
  type: _constants.INPUT_TYPES.NUMBER,
  "default": 10
};
exports["default"] = _default;